import React, { useState, useRef, useEffect } from 'react'
import LiquidBlock from '../blocks/LiquidBlock'
import '../styles/Profile.css'
import verf from '../imgs/verf.svg'

const Profile = ({ userData }) => {
  const [showHint, setShowHint] = useState(false)
  const hintRef = useRef(null)

  // Закрытие подсказки при клике вне области

  return (
    <section className='profileSection'>
      <LiquidBlock>
        <div className="userTopData">
          <h2>{userData?.firstName} <span className='secthernameus'>{userData?.secondName} {userData?.thirdName}</span></h2>
          <div className="verfIconContainer">
            {userData?.verified ? <img 
              className="verfIcon" 
              src={verf} 
              alt="Подтвержденный профиль" 
            /> : null}
          </div>
        </div>
      </LiquidBlock>
      <LiquidBlock>
        <h3>Раздел в разработке</h3>
      </LiquidBlock>
      <LiquidBlock>
        <h3>Dev: Vladislav Dmitriev</h3>
        <p>Da_Vinchi | 2025</p>
      </LiquidBlock>

    </section>
  )
}

export default Profile